import { useQuery } from 'react-query';
import {
    getOrganizationMetadata,
    getOrganizations
} from '../../api/organizations-api';

const key = 'organizationData';

export const useOrganizations = () => {
    return useQuery([key], getOrganizations, {
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
};
export const useGetOrganizationMetadata = idOrganization => {
    return useQuery(
        [key, 'metadata', idOrganization],
        getOrganizationMetadata,
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false
        }
    );
};
